import { debounce } from 'lodash/fp'
import { action, makeAutoObservable } from 'mobx'

import type Service from '@src/service'
import makePersistable from '@src/service/storage/makePersistable'

type Coordinates = {
  top: number
  bottom: number
  left: number
  right: number
}

export default class CallDialogController {
  private defaultCoordinates = {
    top: Infinity,
    left: Infinity,
    right: 30,
    bottom: 30,
  }

  initialCoordinates = this.defaultCoordinates

  coordinates: Coordinates = this.initialCoordinates

  constructor(private service: Service) {
    makeAutoObservable(this, {}, { autoBind: true })

    makePersistable(this, 'CallDialog', {
      initialCoordinates: service.storage.sync(),
    })

    this.coordinates = this.initialCoordinates
  }

  setInitialCoordinates = debounce(
    200,
    action((coordinates: Coordinates) => {
      this.initialCoordinates = coordinates
    }),
  )

  setCoordinates(coordinates: Coordinates) {
    this.coordinates = coordinates
    this.setInitialCoordinates(this.coordinates)
  }

  resetCoordinates() {
    this.coordinates = this.defaultCoordinates

    // as infinity is not serializable the best way to reset the initialCoordinates
    // is to set the initial coordinates to default and then remove the record from local storage
    //
    // on another note, this has to be in a timeout to win over the debounce above
    setTimeout(() => {
      this.initialCoordinates = this.defaultCoordinates
      this.service.storage.sync().delete('CallDialog.initialCoordinates')
    }, 300)
  }
}
